import React from 'react'

export const SidebarData = [
    {
        title: 'Dashboard',
        link: '/userdashboard',
    },
    {
        title: 'Hire Caretaker',
        link: '/hirect',
    },
    {
        title: 'Attend Event',
        link: '/attendevent',
    },
    {
        title: 'Create Event',
        link: '/createevent',
    },
    {
        title: 'Medication',
        link: '/medication',
    },
    {
        title: 'My Requests',
        link: '/myrequests',
    },
]